<template>
    <header class="header navbar navbar-dark flex-md-nowrap">
        <div class="header__container container-fluid">
            <a class="header__hlogo hlogo hover-opacity" href="/" title="Digital services intellectual software development">
                <img src="/images/logo-white-rus.svg" alt="">
            </a>
            <button class="header__navbar-toggler navbar-toggler d-md-none collapsed hover-opacity" type="button"
                data-bs-toggle="collapse" data-bs-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false"
                aria-label="Toggle navigation">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
            </button>

            <div v-if="importantNotification" class="header__important-nofification">
                <svg @click="toggleShowModal" style="cursor: help;" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="24" height="24" rx="6" fill="#E59708"/>
                    <path d="M12 9V14" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                    <circle cx="12" cy="17" r="1" fill="white"/>
                </svg>
                <div class="header__important-nofification__text">
                    {{ notificationText }}
                </div>
                <svg @click="closeImportantNotification" class="header__important-nofification__close-button" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 4.00004L4 14M3.99996 4L13.9999 14" stroke="#A8A8A8" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
            </div>

            <div v-if="show_notification" class="header__notifi notifi">
                <svg class="notifi__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10 5a2 2 0 114 0 7 7 0 014 6v3a4 4 0 002 3H4a4 4 0 002-3v-3a7 7 0 014-6zM9 17v1a3 3 0 006 0v-1"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <div class="notifi__msg" v-if="pinned.text">
                    {{ pinned.text }}
                </div>
                <a class="notifynum hover-opacity" href="#" title="Все оповещения">
                    <svg class="notifynum__icon" width="17" height="17" viewBox="0 0 17 17" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M16.0946 13.6265C15.589 13.1769 15.1463 12.6615 14.7786 12.0942C14.3771 11.311 14.1364 10.4557 14.0708 9.57857V6.995C14.0742 5.61724 13.5732 4.28563 12.6618 3.25037C11.7504 2.21511 10.4914 1.54746 9.12127 1.37285V0.698192C9.12127 0.51302 9.04753 0.335432 8.91626 0.204496C8.785 0.0735594 8.60696 0 8.42132 0C8.23568 0 8.05765 0.0735594 7.92638 0.204496C7.79511 0.335432 7.72137 0.51302 7.72137 0.698192V1.38331C6.36354 1.5705 5.11973 2.24219 4.22031 3.27398C3.32089 4.30576 2.8268 5.62771 2.82956 6.995V9.57857C2.7639 10.4557 2.52325 11.311 2.12175 12.0942C1.76044 12.6602 1.3249 13.1756 0.826703 13.6265C0.770775 13.6755 0.725952 13.7359 0.695215 13.8035C0.664478 13.8711 0.648532 13.9445 0.648438 14.0188V14.73C0.648438 14.8687 0.703677 15.0018 0.802004 15.0998C0.900331 15.1979 1.03369 15.253 1.17275 15.253H15.7485C15.8876 15.253 16.021 15.1979 16.1193 15.0998C16.2176 15.0018 16.2729 14.8687 16.2729 14.73V14.0188C16.2728 13.9445 16.2568 13.8711 16.2261 13.8035C16.1953 13.7359 16.1505 13.6755 16.0946 13.6265ZM1.739 14.207C2.22682 13.737 2.65633 13.2102 3.01832 12.6381C3.52407 11.6922 3.81916 10.6486 3.88343 9.57857V6.995C3.86263 6.38207 3.9657 5.77124 4.1865 5.19887C4.4073 4.62651 4.74131 4.10432 5.16864 3.66339C5.59597 3.22247 6.10788 2.87183 6.67389 2.63235C7.23991 2.39288 7.84844 2.26947 8.46327 2.26947C9.07809 2.26947 9.68663 2.39288 10.2526 2.63235C10.8187 2.87183 11.3306 3.22247 11.7579 3.66339C12.1852 4.10432 12.5192 4.62651 12.74 5.19887C12.9608 5.77124 13.0639 6.38207 13.0431 6.995V9.57857C13.1074 10.6486 13.4025 11.6922 13.9082 12.6381C14.2702 13.2102 14.6997 13.737 15.1875 14.207H1.739Z"
                            fill="currentColor" />
                        <path
                            d="M8.48718 16.9998C8.81746 16.9922 9.13441 16.8683 9.38197 16.6501C9.62952 16.4319 9.79173 16.1334 9.8399 15.8074H7.08203C7.13156 16.1423 7.30136 16.4478 7.55984 16.6671C7.81831 16.8865 8.14786 17.0047 8.48718 16.9998Z"
                            fill="currentColor" />
                    </svg>
                    <span>16</span>
                </a>

                <!-- Этого не -->
                <!--<div class="close_notification hover-opacity">
                    <a @click="closeNotification(pinned.id)">
                        <font-awesome-icon icon="fa-solid fa-xmark" />
                    </a>
                </div>-->
            </div>

            <a :href="documentation_path" class="header__login login hover-opacity">
                Документация
            </a>

            <a v-bind:href="!user ? route_login : '/profile'" class="header__login login hover-opacity">
                <img v-if="user" class="login__avatar" src="/images/avatar.svg" alt="">
                <div class="login__name">{{ !user ? 'Войти' : user }}</div>
            </a>

            <div v-if="user" class="header__navbar navbar-nav">
                <div class="nav-item text-nowrap">
                    <a class="nav-link px-3 hover-opacity" :href="route_logout" title="Выход">
                        <img src="/images/logout.svg" alt="">
                    </a>
                </div>
            </div>
        </div>
        <NotificationModal
            v-if="showModal"
            @closeModal="toggleShowModal"
            :modalTitle="notificationTitle"
            :modalBody="notificationText"
        />
    </header>
</template>

<script>

import Notification from "../models/Notification";
import NotificationModal from "../modals/NotificationModal.vue";

export default {
    name: "HeaderComponent",
    components: {NotificationModal},
    props: {
        route_login: String,
        route_logout: String,
        route_notifications_pinned: String,
        route_readed: String,
        user: String,
        documentation_path: String,
    },
    data: function () {
        return {
            notificationTitle: 'Важное уведомление',
            notificationText: 'Уважаемые пользователи! В связи с проведением технических работ наш сайт будет временно недоступен. Пожалуйста, попробуйте зайти на него позже. Мы приносим свои извинения за неудобства.',
            notification: new Notification({
                route_list: this.route_notifications_pinned,
            }),
            pinned: {
                id: 0,
                text: '',
            },
            importantNotification: false,
            show_notification: 0,
            showModal: false,
        };
    },
    methods: {
        getNotifications: async function () {
            let notifications = await this.notification.loadNotification();

            if (notifications.item[0]) {
                this.show_notification = 1;
                this.pinned.id = notifications.item[0].id;
                this.pinned.text = notifications.item[0].name;
            }

        },
        closeNotification: function (id) {
            this.show_notification = 0;
            this.notification.readed_notify(this.route_readed, id);
        },
        showImportantNotification: function () {
            // this.notificationTitle =
            // this.notificationText =
            this.importantNotification = !this.importantNotification;
        },
        closeImportantNotification: function () {
            this.importantNotification = !this.importantNotification;
        },
        toggleShowModal: function (row) {
            if (!this.showModal) {
                this.modalTitle = row.header;
                this.modalBody = row.preview;
                this.showModal = !this.showModal;
            } else {
                this.showModal = !this.showModal;
            }
        }
    },
    mounted() {
        // this.getNotifications();
    }
};
</script>

<style scoped>
.header-left-block {
    flex: 0 0 50%;
}

.header-right-block {
    flex: 0 0 50%;
}

.float-right {
    float: right;
}
</style>
